export default __webpack_public_path__ + "locales/de/HotkeysPanel.json?hash=f79ced5c0390db7b51160714eefbb394";